import { styled, Container } from '@teko/ds-desktop';
import React from 'react';

const TOPBAR_HEIGHT = 42;
const Topbar = ({
  rightMenu = [],
  leftMenu = []
}) => {
  return /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement(StyledContainer, null, /* @__PURE__ */ React.createElement(MenuWrapper, null, leftMenu.map((item, index) => /* @__PURE__ */ React.createElement(React.Fragment, {
    key: index
  }, item))), /* @__PURE__ */ React.createElement(MenuWrapper, null, rightMenu.map((item, index) => /* @__PURE__ */ React.createElement(React.Fragment, {
    key: index
  }, item)))));
};
const Wrapper = styled.div(({ theme }) => `
  @media print {
    display: none;
  }
  background-color: ${theme == null ? void 0 : theme.colors.primary500};
  height: ${TOPBAR_HEIGHT}px;
`);
const StyledContainer = styled(Container)`
  display: flex;
  justify-content: space-between;
`;
const MenuWrapper = styled.div`
  display: flex;
  .button-text {
    font-weight: 500;
  }
`;

export { TOPBAR_HEIGHT, Topbar };
